import { useFetch } from "../../../hooks/fetch-data/config";
import { GetMouCompany } from "../../../services/modules/mou";

export const useFetchMouCompanies = () => {
  return useFetch({
    queryKey: ["mou-companies"],
    queryFn: async () => {
      const { resultData } = await GetMouCompany();

      return resultData;
    },
  });
};
